module.exports = __webpack_public_path__ + "img/background-login-v5.41c203b7.png";